/**
 * Application Layout Component
 *
 * Provides the base layout structure for all public-facing pages.
 * Includes:
 * - Header with branding
 * - Main content area (via Outlet)
 * - Footer with links
 *
 * Branding is loaded from the API based on tenant configuration.
 */

import type { ReactElement } from "react";
import { Outlet } from "react-router-dom";

import { Footer } from "./Footer";
import { Header } from "./Header";

export function AppLayout(): ReactElement {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
